import {createRouter, createWebHistory} from "@ionic/vue-router";
// import Home from "../views/Home.vue";
import Splash from "../views/Splash.vue";
import SignIn from "@/views/Auth/SignIn";
import List from "../views/Registers/List.vue";
import Register from "@/views/Registers/Register.vue";
import NotificationsList from "@/views/Registers/NotificationsList.vue";
import GeneratedReportsRegister from "@/views/Registers/GeneratedReportsRegister.vue";
import TabNavigation from '@/components/Templates/TabNavigation'
import ReportsList from '@/views/Registers/ReportsList'

const createTabsRoutes = ({route, props, listComponent}) => {
  route.path = route.path;
  route.component = listComponent; //Content
  route.props = props;
  route.meta = {...route.meta};

  return route;
};

const createCrudRoutes = ({route, props, registerComponent}) => {
  let routes = [];

  if (props.claims.view)
    routes.push({
      path: "/tabs/" + route.path + "/detalhes/:id",
      name: `Detalhes do Item - ${route.name}`,
      component: registerComponent,
      props: {...props, readonly: true},
      meta: {...route.meta, menu: false, claimRoute: "view", title: "Detalhes"},
    });

  // if (props.claims.add && (userData.companies[this.companySelected.groupCompany].admin || userData?.rules?.find(rId => userRules.find(ur => ur.id === rId && eval(`ur.claims?.${props.register}?.add`)))))
  if (props.claims.add) {

    routes.push({
      path: "/tabs/" + route.path + "/cadastrar",
      name: `Cadastrar ${route.name}`,
      component: registerComponent,
      props,
      meta: {...route.meta, menu: true, title: "Cadastrar", claimRoute: "add", icon: "mdi-plus"},
    });

    /**
     * TO-DO
     * Lembrar de fazer esse tratamento para cópia e deixar algo mais genérico
     */
    if (route.register === "SC5")
      routes.push({
        path: "/tabs/" + route.path + "/bonificar/:id",
        name: `Bonificar ${route.name}`,
        component: registerComponent,
        props,
        meta: {...route.meta, menu: false, title: "Cadastrar", claimRoute: "add", icon: "mdi-plus"},
      });
  }

  // if (props.claims.edit && (userData.companies[this.companySelected.groupCompany].admin || userData?.rules?.find(r => eval(`r.claims?.${props.register}?.edit`))))
  if (props.claims.edit)
    routes.push({
      path: "/tabs/" + route.path + "/editar/:id",
      name: `Editar Item - ${route.name}`,
      component: registerComponent,
      props: {...props, edit: true},
      meta: {...route.meta, menu: false, claimRoute: "edit", title: "Editar"},
    });

  return routes;
};

const createDashRoutes = ({route, registerComponent, reports}) => {
  let routes = [];

  reports.map((propReport) => {
    routes.push({
      path: route.path + "/detalhes/" + propReport.id,
      name: propReport.name,
      component: registerComponent,
      props: propReport,
      meta: {...route.meta, icon: propReport.icon, menu: true, claimRoute: "view"},
    });
  });

  return routes;
};

const createCustomRouter = ({integrations, userRules = [], reports = [], superAdmin = false}) => {
  let generatedTabsRoutes = [];
  let generatedCrudRoutes = [];

  /** Dashboard routes */
  const reportsRoute = {
    path: "/tabs/reports",
    name: "Relatórios",
    register: "reports",
  };

  const propsFromReports = reports.map((report) => ({
    ...report,
    title: report.name,
    name:  `reports_${report.id}`,
    claims: {
      add: false,
      sync: false,
      view: true,
      edit: false,
      delete: false,
    },
  }));

  for (const integration of integrations) {
    if(integration.collection){

      let orderBy = integration.orderBy || ''
      try {
        if (['{', '['].some(symbol => orderBy.includes(symbol)))
          orderBy = JSON.parse(orderBy)
      } catch (e) {
        console.warn(`Error when trying to define "orderBy" in route ${integration.name}.`, e)
      }

      let filters = ''
      try {
        filters = (integration.filters) ? JSON.parse(integration.filters) : null
      } catch (e) {
        console.warn(`Error when trying to define "filters" in route ${integration.name}.`, e)
      }

      let filtersSaller = ''
      try {
        filtersSaller = (integration.filtersSaller) ? JSON.parse(integration.filtersSaller) : null
      } catch (e) {
        console.warn(`Error when trying to define "filtersSaller" in route ${integration.name}.`, e)
      }
   
      let filtersClient = ''
      try {
        filtersClient = (integration.filtersClient) ? JSON.parse(integration.filtersClient) : null
      } catch (e) {
        console.warn(`Error when trying to define "filtersClient" in route ${integration.name}.`, e)
      }

      let filtersSubcollection = integration.filtersSubcollection || ''
      try {
        if (['{', '['].some(symbol => filtersSubcollection.includes(symbol))) { filtersSubcollection = JSON.parse(filtersSubcollection) }
      } catch (e) {
        console.warn(`Error when trying to define "filtersSubcollection" in route ${integration.name}.`, e)
      }
     
      let orderSubcollection = integration.orderSubcollection || ''
      try {
        if (['{', '['].some(symbol => orderSubcollection.includes(symbol)))
          orderSubcollection = JSON.parse(orderSubcollection)
      } catch (e) {
        console.warn(`Error when trying to define "orderSubcollection" in route ${integration.name}.`, e)
      }

      let validation = integration.validation || ''
      try {
        if (validation.includes('=>')) { validation = eval(validation) }
      } catch (e) {
        console.warn(`Error when trying to define "validation" in route ${integration.name}.`, e)
      }

      const parentRoute = {
        path: `${integration.collection}`,
        name: integration.name,
        register: integration.register,
        meta: {
          menu: true,
          icon: integration.listIcon || 'mdi-lan-connect',
          requiresAdmin: integration.requiresAdmin || false
        },
      }

      const props = {
        ...integration,
        integration: true,
        filters,
        filtersSaller,
        filtersClient,
        orderBy,
        filtersSubcollection,
        orderSubcollection,
        validation,
        claims: {
          add: integration.add || false,
          sync: integration.sync || false,
          view: integration.view || true,
          edit: integration.edit || false,
          delete: integration.delete || false,
          offline: integration.offline || false,
        },
      }  

      generatedTabsRoutes.push(createTabsRoutes({route: parentRoute, props: {...props, props}, listComponent: List}));
      generatedCrudRoutes.push(...createCrudRoutes({route: parentRoute, props: {...props, props}, registerComponent: Register}));
    }
  }

  generatedTabsRoutes.push(createTabsRoutes({route: {path: 'reports', name: 'Relatórios'}, listComponent: ReportsList, props: {reports: propsFromReports}}));
  generatedCrudRoutes.push(...createDashRoutes({route: reportsRoute, registerComponent: GeneratedReportsRegister, userRules, reports: propsFromReports}));

  return { generatedCrudRoutes, generatedTabsRoutes }
};

const initRouter = () => {
  const routes = [
    {
      path: "/login",
      name: "Entrar",
      component: SignIn,
      meta: {public: true, menuPublic: true},
    },
    {
      path: "/splash",
      name: "Aguarde",
      component: Splash,
      meta: {},
    },
    {
      path: "/notifications/listar",
      component: NotificationsList,
    },
    {
      path: '/',
      redirect: '/tabs/SC5'
    },
    {
      path: '/tabs/',
      name: 'Tabs',
      component: TabNavigation,
      children:[
        {
          path: 'SC5',
          component: List
        },
        {
          path: 'SC5/cadastrar',
          component: Register
        },
        {
          path: 'SA1',
          component: List
        },
        {
          path: 'SA1/cadastrar',
          component: Register
        },
        {
          path: 'reports',
          component: ReportsList
        }
      ]
    },
  ];
 
  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  return router;
}

export default { createCustomRouter, initRouter };
